import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down_68b60",
  "use": "arrow-down_68b60-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol viewBox=\"0 0 10 7\" id=\"arrow-down_68b60\">\n    <use xlink:href=\"#arrow-down_68b60_path0_fill\" />\n    <defs>\n        <path id=\"arrow-down_68b60_path0_fill\" d=\"M10 1.5l-5 5-5-5L1.5 0 5 3.5 8.5 0 10 1.5z\" />\n    </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol